import { useState } from 'react'
import { useNavigate, Link, useSearchParams } from 'react-router-dom'
import { useQueryClient } from '@tanstack/react-query'
import { auth, ApiError } from '../lib/api'
import { safeNotice } from '../lib/notices'
import { useRedirectIfAuthenticated } from '../lib/useRedirectIfAuthenticated'
import { AuthLayout, ErrorBox, NoticeBox, Field, SubmitButton } from '../components/AuthLayout'

export function Login() {
  const navigate = useNavigate()
  const queryClient = useQueryClient()
  const [params] = useSearchParams()
  useRedirectIfAuthenticated()
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState('')
  const [busy, setBusy] = useState(false)

  async function onSubmit(e: React.FormEvent) {
    e.preventDefault()
    setError('')
    setBusy(true)
    try {
      const res = await auth.login(email, password)
      if (res.totp_required && res.challenge) {
        navigate(`/login/totp?challenge=${encodeURIComponent(res.challenge)}`)
        return
      }
      await queryClient.invalidateQueries({ queryKey: ['me'] })
      navigate('/dashboard')
    } catch (err) {
      setError(err instanceof ApiError ? err.message : 'E-mail of wachtwoord klopt niet.')
    } finally {
      setBusy(false)
    }
  }

  return (
    <AuthLayout title="Inloggen">
      <ErrorBox>{error}</ErrorBox>
      <NoticeBox>{safeNotice(params.get('notice'))}</NoticeBox>
      <form onSubmit={onSubmit}>
        <Field label="E-mail" type="email" required autoFocus value={email} onChange={(e) => setEmail(e.target.value)} />
        <Field label="Wachtwoord" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} />
        <SubmitButton disabled={busy}>Inloggen</SubmitButton>
      </form>
      <p className="mt-4 text-sm text-ink-soft">
        Nog geen account? <Link to="/signup" className="text-amber">Aanmelden</Link>
      </p>
    </AuthLayout>
  )
}
